import type { WidgetType } from "@csbi/contracts"

export const WIDGET_LABELS: Record<WidgetType, string> = {
  "stat-tile": "Stat tile",
  bar: "Bar chart",
  hbar: "Horizontal bar chart",
  "stacked-bar": "Stacked bar chart",
  line: "Line chart",
  pie: "Pie / donut chart",
  table: "Table",
  histogram: "Histogram",
  gauge: "Gauge",
  map: "Map",
}
